function initToggle(el) {
  const name = el.getAttribute('data-modal-toggle');
  const elModal = document.querySelector(`[data-modal=${name}]`);
  if (!elModal) {
    return;
  }

  el.addEventListener('click', () => {
    elModal.classList.toggle('modal--open');
  });
}

function init() {
  const toggles = document.querySelectorAll('[data-modal-toggle]');
  [...toggles].forEach(initToggle);
}

export default {init};
